module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shikan-d770b7a2f145856b758748922bc9ebdf.png";